import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyCharges.vue?vue&type=template&id=c97664f8"
import script from "./MoleculeEditionBillingAcademyCharges.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports